import { Component, OnInit } from '@angular/core';
import { Session } from 'src/app/models/session';
import { ConfirmService } from '../confirm/confirm.service';

@Component({
  selector: 'app-nav-header',
  templateUrl: './nav-header.component.html',
  styleUrls: ['./nav-header.component.css']
})
export class NavHeaderComponent implements OnInit {

  constructor(public session: Session, private confirm: ConfirmService) { }

  ngOnInit() {
  }

  logOut(){
    this.confirm.confirm('Cerrar sesión', 'Está seguro que desea cerrar sesión?', "SI", "NO")
    .then((confirmed) => { if(confirmed)this.session.logout();})
    .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
    
  }
}
